export var Roles;
(function (Roles) {
    Roles["None"] = "none";
    Roles["Teacher"] = "teacher";
    Roles["Supervizor"] = "supervizor";
})(Roles || (Roles = {}));
